
import { Card, CardText } from 'material-ui/Card';
import { deleteDiagnosisData, getPatientDiagnosisList, getPatientMasterData } from '../../actions/PatientActions';
import { showFormatedDate, base64Decode, alertConfirmation } from '../../../../actions/utilAction';
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import Paginator from '../../../../components/pagination';
import PatientInfo from '../../patient_info';
import ProblemModal from './problem-modal';
import Tooltip from '../../../../components/Tooltip';


class ProblemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      diagnosisList: [],
      pateint_id: props.match.params.id ? base64Decode(props.match.params.id) : null,
      includedData: [],
      patientMasterData: [],
      meta_data: null,
      diagnosisId: null,
    };
  }

  componentWillMount = () => {
    let masterData = {
      'masterdata': 'MASTERICD',
    };
    this.props.getPatientMasterData(masterData);
    this.loadData();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ diagnosisId: null });
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleEditClick = (event, diagnoseObj) => {
    Alert.closeAll();
    this.setState({ open: true, diagnosisId: diagnoseObj.id });
  }

  handleAlertClick = (event, diagnosis_id) => {
    this.props.deleteDiagnosisData(diagnosis_id);
    Alert.closeAll();
  }

  handleDeleteClick = (event, diagnoseObj) => {
    alertConfirmation('Are you sure you want to delete client\'s diagnosis?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: diagnoseObj.id,
      },
    });
  }

  loadData(page_number) {
    let searchObj = {
      contain_filters: { patientId: this.state.pateint_id },
      sortColumn: 'id',
      sortOrder: 'desc',
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getPatientDiagnosisList(searchObj);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.patientMasterData && this.props.patientMasterData !== nextProps.patientMasterData) {
      this.setState({ patientMasterData: nextProps.patientMasterData });
    }
    if (nextProps.diagnosisList && this.props.diagnosisList !== nextProps.diagnosisList) {
      this.setState({
        diagnosisList: nextProps.diagnosisList.data || [],
        meta_data: nextProps.diagnosisList.meta,
      });
    }
    if (nextProps.diagnosis_deleted && this.props.diagnosis_deleted !== nextProps.diagnosis_deleted) {
      this.loadData();
    }
    if (nextProps.saved_patientDiagnosis && this.props.saved_patientDiagnosis !== nextProps.saved_patientDiagnosis) {
      this.loadData();
    }
  }

  renderDiagnosisCards = () => {
    return this.state.diagnosisList.map((diagnosisObj, index) => {
      return (
        <div className="col-sm-6 history_card mt20" key={index}>
          <Card>
            {this.props.updatePermission || this.props.deletePermission ?
              (<div className="cardactbtn">
                {
                  this.props.updatePermission ?
                    <button onClick={(e) => this.handleEditClick(e, diagnosisObj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                    : null
                }
                {
                  this.props.deletePermission ?
                    <button onClick={(e) => this.handleDeleteClick(e, diagnosisObj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    : null
                }
              </div>)
              : null
            }
            <div className="carditems">
              <ul>
                <li>Diagnosis Date: <span>{diagnosisObj.diagnosisDate ? showFormatedDate(diagnosisObj.diagnosisDate) : '-'}</span></li>

                <li>Status : {diagnosisObj.isActive ? <span className="greenfont">Active</span> : <span className="yellowfont">Inactive</span> }</li>
              </ul>
            </div>
            <CardText className="disascontent" expandable={false}>
              <p>Diagnosis</p>
              <span>{diagnosisObj.diagnosis && <Tooltip Description={diagnosisObj.diagnosis} />}
                {(diagnosisObj.diagnosis || '').length > 50 ? (diagnosisObj.diagnosis || '').substring(0, 50) + '...' : (diagnosisObj.diagnosis || '-')}</span>
            </CardText>
          </Card>
        </div>
      );
    });
  }

  renderNoRecordFound() {
    return (
      <div className="col-sm-12 history_card mt20">
        <div className="familydl text-center no-record">
          No record found.
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.open ? <ProblemModal patientMasterData={this.state.patientMasterData} diagnosisId={this.state.diagnosisId} patientid={this.state.pateint_id} closeDialog={this.handleClose} /> : null}
        <h2 className="page_title">Client Diagnosis</h2>
        <PatientInfo patientId={this.state.pateint_id} />
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            {this.props.addPermission ?
              <CommonButton label="Add Diagnosis" primary={true} onTouchTap={this.handleOpen} />
              : null
            }
            <div className="row">
              {this.state.diagnosisList.length > 0 ? this.renderDiagnosisCards() : this.renderNoRecordFound()}

            </div>
            <Paginator data={this.state.meta_data} handlePageChange={(page_number) => this.loadData(page_number)} />
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLIENT_DIAGNOSIS_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_DIAGNOSIS_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_DIAGNOSIS_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_DIAGNOSIS_LIST_DELETE')[0].permission : false;

  // End For Role Permission

  return {
    patientMasterData: state.patient.patientMasterData,
    history_created: state.patient.history_created,
    diagnosisList: state.patient.diagnosisList,
    saved_patientDiagnosis: state.patient.saved_patientDiagnosis,
    diagnosis_deleted: state.patient.diagnosis_deleted,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
};

export default connect(mapStateToProps, { getPatientDiagnosisList, deleteDiagnosisData, getPatientMasterData })(ProblemList);



// WEBPACK FOOTER //
// ./src/modules/patients/components/diagnosis/patient-problemlist.js